import React from 'react';
import POSInterface from '../components/orders/POSInterface';

const POS = () => {
  return (
    <div className="page-container-full">
      <POSInterface />
    </div>
  );
};

export default POS;